import SimpleBarChart from './SimpleBarChart';

export default SimpleBarChart;
